

(function () {

    angular.module('tmx-app')
        .controller('pjpEditCtrl', ['$scope', 'resolvedData', '$state', 'ToastService', 'LoanApplicationService', '$mdDialog', '$mdMedia', '$rootScope', 'lookupService',
            function PjpEditCtrl($scope, resolvedData, $state, ToastService, LoanApplicationService, $mdDialog, $mdMedia, $rootScope, lookupService) {
                var pjpVM = this;

                //#region  ----------Variables ---------------------------------------
                pjpVM.tempDate = new Date().toJSON();
                pjpVM.CurrentJSONDate = pjpVM.tempDate.split('T')[0] + "T18:59:59";
                pjpVM.CurrentDate = new Date(pjpVM.CurrentJSONDate);
                pjpVM.YesterDate = new Date();
                pjpVM.YesterDate.setDate(pjpVM.YesterDate.getDate() - 1);
                pjpVM.tasksDetails = [];
                pjpVM.LoanApplicationService = LoanApplicationService;
                pjpVM.geofenceFields = [];
                pjpVM.removedGeofences = [];
                pjpVM.removedTasks = [];
                pjpVM.disabledGeofences = [];
                pjpVM.tasksFields = [];
                pjpVM.geofenceCount = 0;
                pjpVM.clusterCount = 1;
                pjpVM.tasksCount = 0;
                pjpVM.tasksDetailsCount = 1;
                pjpVM.tasks = [];
                pjpVM.lookup = {};
                pjpVM.date = new Date();
                pjpVM.readonly = false;
                pjpVM.isEdit = false;
                pjpVM.CreatedDateReadonly = false;
                pjpVM.geofences = resolvedData.Geofences.data;
                pjpVM.showFrequencyDropdown = showFrequencyDropdown;
                pjpVM.showFrequencyText = showFrequencyText;
                pjpVM.EffectiveEndDateChange = EffectiveEndDateChange;
                pjpVM.multi = false;
                pjpVM.daily = 'All Days';
                pjpVM.monthly = 'Day of the Month';
                pjpVM.single = true;

                pjpVM.DaysList = new Array(31).fill().map((e, i) => ({ LookupId: i + 1, VisibleValue: String(i + 1), LookupType: "DAYS_LIST" }));
                pjpVM.getVisibleValueOfRepeat = getVisibleValueOfRepeat;
                pjpVM.selectDay = selectDay;
                pjpVM.minDate = new Date(moment(new Date()).startOf('day').toISOString());
                pjpVM.startDate = new Date(moment(new Date()).startOf('day').toISOString());
                pjpVM.endDate = new Date(moment(new Date()).endOf('day').toISOString());

                //#endregion

                //#region  ========== Scope functions=========================

                pjpVM.click = function () {
                    $rootScope.$broadcast('changeText', {});
                }
                pjpVM.addGeofenceField = function () {
                    if (!angular.isDefined(pjpVM.geofenceCount))
                        pjpVM.geofenceCount = 1;

                    var item = {
                        GeofenceId: "",
                        RouteSequence: "",
                        GeofencePoints: "",
                        EffectiveStartDate: "",
                        EffectiveEndDate: "",

                    };

                    pjpVM.geofenceFields.splice(0, 0, item);
                    pjpVM.geofenceCount++;
                    var r1 = {
                        HiddenValue: pjpVM.geofenceCount,
                        VisibleValue: pjpVM.geofenceCount.toString()
                    };
                    pjpVM.routes.push(r1);
                };

                pjpVM.assignedSequence = function (length, ary) {
                    for (var i = 0; i < ary.length; i++) {
                        ary[i].sequence = length + i + 1;
                    }
                }

                pjpVM.getLoanAppInputFilters = function () {
                    return [
                        { "field": "Status", "operator": "eq", "value": "Draft" }
                    ];
                };

                pjpVM.addTasksDetail = function () {
                    if (!angular.isDefined(pjpVM.tasksDetailsCount))
                        pjpVM.tasksDetailsCount = 1;

                    var item = {
                        Type: "",
                        Description: "",
                        TaskSequence: "",
                        GeofenceOrLoanApplication: "",
                        EffectiveStartDate: "",
                        EffectiveEndDate: "",
                        Index: (pjpVM.tasksDetails.length == 0 ? -1 : pjpVM.tasksDetails.length),
                        isMobilization: false,
                        'GeofencePJPId': '0'
                    };
                    pjpVM.tasksDetails.splice(0, 0, item);
                    pjpVM.tasksDetailsCount++;
                    var t1 = {
                        HiddenValue: pjpVM.tasksDetailsCount,
                        VisibleValue: pjpVM.tasksDetailsCount.toString()
                    };
                    pjpVM.tasks.push(t1);

                };


                pjpVM.getVisiblePjpTypeValue = function (selectedType) {
                    if (angular.isDefined(pjpVM.pjpTypes)) {
                        for (var i = pjpVM.pjpTypes.length - 1; i >= 0; i--) {
                            if (pjpVM.pjpTypes[i].LookupId == selectedType) {
                                return pjpVM.pjpTypes[i].VisibleValue;
                            }
                        }

                        return "";
                    }
                    else {
                        return "";
                    }
                }


                pjpVM.removeGeofenceRow = function (Index) {
                    for (var i = 0; i < pjpVM.tasksDetails.length; i++) {
                        if (pjpVM.tasksDetails.Index > Index && pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails.Type) == "Mobilization") {
                            pjpVM.tasksDetails.Index = pjpVM.tasksDetails.Index - 1;

                        }
                    }

                    pjpVM.geofenceFields.splice(Index, 1);
                    pjpVM.geofenceCount--;

                }

                pjpVM.removeTasksFeildRow = function (Index) {
                    for (var i = 0; i < pjpVM.tasksDetails.length; i++) {
                        if (pjpVM.tasksDetails.Index > Index && pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails.Type) != "" && pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails.Type) != "Mobilization") {
                            pjpVM.tasksDetails.Index = pjpVM.tasksDetails.Index - 1;
                        }
                    }

                    if (pjpVM.isEdit && pjpVM.tasksFields[Index].LoanApplicationId != "0") {
                        pjpVM.pjpVM.tasksFields[i].EffectiveEndDate = new Date("2015-01-01").toJSON();
                        pjpVM.removedTasks.push(pjpVM.tasksFields[Index]);
                    }

                    pjpVM.tasksFields.splice(Index, 1);
                    pjpVM.tasksCount--;

                }

                pjpVM.addGeofenceFieldRow = function () {
                    var item = {
                        GeofenceId: "0",
                        RouteSequence: "",
                        GeofencePoints: "",
                        EffectiveStartDate: "",
                        EffectiveEndDate: "",

                    };
                    pjpVM.geofenceFields.push(item);
                }

                pjpVM.addTasksFeildRow = function () {

                    var item = {
                        LoanApplicationId: "0",
                        Type: "",
                        Description: "",
                        TaskSequence: "",
                        EffectiveStartDate: "",
                        EffectiveEndDate: "",

                    };
                    pjpVM.tasksFields.push(item);
                }
                pjpVM.isMobilization = function (task) {
                    if (task.isMobilization == true) {
                        return task.isMobilization;
                    }
                }
                pjpVM.onTypeChange = function (Type, task) {
                    var TypeVisible = pjpVM.getVisiblePjpTypeValue(Type);
                    var PreTypeVisible = pjpVM.getVisiblePjpTypeValue(task.Type)
                    if (TypeVisible == "") {
                        if (PreTypeVisible == "Mobilization") {
                            pjpVM.removeGeofenceRow(task.Index);
                            task.Index = -1;
                        }
                        else if (PreTypeVisible != "") {
                            pjpVM.removeTasksFeildRow(task.Index);
                            task.Index = -1;
                        }
                    }
                    else if (TypeVisible == "Mobilization") {
                        if (PreTypeVisible == "") {
                            pjpVM.addGeofenceFieldRow();
                            task.Index = pjpVM.geofenceCount;
                            pjpVM.geofenceCount++;
                        }
                        else if (PreTypeVisible != "") {
                            pjpVM.removeTasksFeildRow(task.Index);
                            pjpVM.addGeofenceFieldRow();
                            task.Index = pjpVM.geofenceCount;
                            pjpVM.geofenceCount++;
                        }
                    }
                    else if (TypeVisible != "") {
                        if (PreTypeVisible == "") {
                            pjpVM.addTasksFeildRow();
                            task.Index = pjpVM.tasksCount;
                            pjpVM.tasksCount++;
                            task.PreType = task.type;
                        }
                        else if (PreTypeVisible == "Mobilization") {
                            pjpVM.removeGeofenceRow(task.Index);
                            pjpVM.addTasksFeildRow();
                            task.Index = pjpVM.tasksCount;
                            pjpVM.tasksCount++;
                            task.PreType = task.type;
                        }
                    }


                    if (TypeVisible == "Mobilization" || TypeVisible == "Follow up Pjp") {
                        task.isMobilization = true;
                    }
                    else {
                        task.isMobilization = false;
                    }

                }

                pjpVM.isMobilization = function (type) {
                    var PreTypeVisible = pjpVM.getVisiblePjpTypeValue(type.Type)
                    if (PreTypeVisible == "Mobilization") {
                        return true;
                    }
                    return false;

                }

                pjpVM.addTasksField = function () {
                    if (!angular.isDefined(pjpVM.tasksCount))
                        pjpVM.tasksCount = 1;

                    var item = {
                        Type: "",
                        Description: "",
                        TaskSequence: "",
                        EffectiveStartDate: "",
                        EffectiveEndDate: "",

                    };
                    pjpVM.tasksFields.splice(0, 0, item);
                    pjpVM.tasksCount++;
                    var t1 = {
                        HiddenValue: pjpVM.tasksCount,
                        VisibleValue: pjpVM.tasksCount.toString()
                    };
                    pjpVM.tasks.push(t1);
                }


                pjpVM.removeGeofenceField = function (geofence) {
                    for (var i = pjpVM.geofenceFields.length - 1; i >= 0; i--) {
                        if (pjpVM.geofenceFields[i].$$hashKey == geofence.$$hashKey) {
                            if (angular.isDefined(pjpVM.vm.TmxGeofencePjp) && pjpVM.vm.TmxGeofencePjp.length > 0) {
                                for (var j = pjpVM.vm.TmxGeofencePjp.length - 1; j >= 0; j--) {
                                    if (pjpVM.geofenceFields[i].GeofenceId == pjpVM.vm.TmxGeofencePjp[j].GeofenceId) {
                                        pjpVM.geofenceFields[i].EffectiveEndDate = new Date("2015-01-01").toJSON();
                                        pjpVM.removedGeofences.push(pjpVM.geofenceFields[i]);
                                        break;
                                    }
                                }
                            }
                            if (pjpVM.geofenceFields.length > 1) {
                                pjpVM.geofenceFields.splice(i, 1);
                            }
                        }
                    }
                    if (pjpVM.routes.length > 1) {
                        pjpVM.routes.splice(pjpVM.routes.length - 1, 1);
                        pjpVM.geofenceCount--;
                    }
                }

                pjpVM.removeTasksDetail = function (tasks) {
                    for (var i = pjpVM.tasksDetails.length - 1; i >= 0; i--) {
                        if (pjpVM.tasksDetails[i].$$hashKey == tasks.$$hashKey) {
                            if (pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails[i].Type) == 'Mobilization') {
                                if (pjpVM.isEdit && pjpVM.tasksDetails[i].GeofencePJPId != "0") {
                                    var t1 = {
                                        'RouteSequence': pjpVM.tasksDetails[i].TaskSequence,
                                        'PjpTypeLkp': pjpVM.tasksDetails[i].Type,
                                        'EffectiveStartDate': pjpVM.vm.EffectiveStartDate,
                                        'EffectiveEndDate': new Date(),
                                        'Description': pjpVM.tasksDetails[i].Description,
                                        'GeofencePJPId': pjpVM.tasksDetails[i].GeofencePJPId,
                                        'TmxGeofence': pjpVM.geofenceFields[pjpVM.tasksDetails[i].Index]
                                    };
                                    pjpVM.removedGeofences.push(t1);
                                }

                                pjpVM.geofenceFields.splice(pjpVM.tasksDetails[i].Index, 1);
                                pjpVM.geofenceCount--;
                            }
                            else if (pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails[i].Type) != "") {
                                if (pjpVM.isEdit && pjpVM.tasksDetails[i].GeofencePJPId != "0") {
                                    t1 = {
                                        'RouteSequence': pjpVM.tasksDetails[i].TaskSequence,
                                        'PjpTypeLkp': pjpVM.tasksDetails[i].Type,
                                        'EffectiveStartDate': pjpVM.vm.EffectiveStartDate,
                                        'EffectiveEndDate': new Date(),
                                        'Description': pjpVM.tasksDetails[i].Description,
                                        'LoanApplicationId': pjpVM.tasksDetails[i].GeofenceOrLoanApplication,
                                        'LoanApplicationPjpId': pjpVM.tasksDetails[i].GeofencePJPId
                                    };
                                    pjpVM.removedTasks.push(t1);
                                }

                                pjpVM.tasksFields.splice(pjpVM.tasksDetails[i].Index, 1);
                                pjpVM.tasksCount--;
                            }


                            pjpVM.tasksDetails.splice(i, 1);
                        }
                    }
                    if (pjpVM.tasks.length > 0) {
                        pjpVM.tasks.splice(pjpVM.tasks.length - 1, 1);
                        pjpVM.tasksDetailsCount--;
                    }
                    for (var j = 0; j < pjpVM.tasksDetails.length; j++) {
                        pjpVM.tasksDetails[j].TaskSequence = length + j + 1;
                        pjpVM.tasksDetails[j].Index = (length + j + 1) - 1;
                    }
                }


                pjpVM.removeTasksField = function (tasks) {
                    for (var i = pjpVM.tasksFields.length - 1; i >= 0; i--) {
                        if (pjpVM.tasksFields[i].$$hashKey == tasks.$$hashKey) {
                            if (angular.isDefined(pjpVM.vm.TmxPjpTasks) && pjpVM.vm.TmxPjpTasks.length > 0) {
                                for (var j = pjpVM.vm.TmxPjpTasks.length - 1; j >= 0; j--) {
                                    if (pjpVM.tasksFields[i].UserId == pjpVM.vm.TmxPjpTasks[j].UserId && pjpVM.tasksFields[i].PjpDate.toString() == new Date(pjpVM.vm.TmxPjpTasks[j].PjpDate).toString()) {
                                        if (pjpVM.tasksFields.length > 1) {
                                            pjpVM.tasksFields[i].EffectiveEndDate = new Date("2015-01-01").toJSON();
                                            pjpVM.removedTasks.push(pjpVM.tasksFields[i]);
                                            pjpVM.tasksFields.splice(i, 1);
                                            break;
                                        }

                                    }
                                }
                            }
                            if (pjpVM.tasksFields.length > 1) {
                                pjpVM.tasksFields.splice(i, 1);
                            }
                        }
                    }
                    if (pjpVM.tasks.length > 1) {
                        pjpVM.tasks.splice(pjpVM.tasks.length - 1, 1);
                        pjpVM.tasksCount--;
                    }
                }

                pjpVM.routeChanged = function (geofence) {
                    if (geofence != null) {
                        for (var i = pjpVM.geofenceFields.length - 1; i >= 0; i--) {
                            if (pjpVM.geofenceFields[i].RouteSequence == geofence) {
                                pjpVM.geofenceFields[i].RouteSequence = null;
                            }
                        }
                    }
                }

                pjpVM.tasksChanged = function (task) {
                    if (task != null) {
                        for (var i = pjpVM.tasksFields.length - 1; i >= 0; i--) {
                            if (pjpVM.tasksFields[i].TaskSequence == task) {
                                pjpVM.tasksFields[i].TaskSequence = null;
                            }
                        }
                    }
                }
                $scope.populatePjpDate = function () {
                    var EndDate;
                    if (pjpVM.vm.EffectiveEndDate) {
                        EndDate = new Date(pjpVM.vm.CreatedDate);//forming a date object from JSON string
                    }
                    else {
                        EndDate = new Date();
                    }

                    return EndDate;
                };

                pjpVM.onPjpDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        pjpVM.vm.CreatedDate = selectedDate.toJSON();//end Date
                    }
                };

                pjpVM.getFormErrors = function () {
                    if (angular.isDefined(pjpVM.dialogForm)) {
                        if (pjpVM.dialogForm.$invalid || pjpVM.vm.CreatedDate == "Invalid Date") {
                            return pjpVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                }

                pjpVM.errorChanged = function (newErrors, oldErrors) {
                    if (newErrors != oldErrors || (pjpVM.vm && pjpVM.vm.CreatedDate && pjpVM.vm.CreatedDate == "Invalid Date")) {
                        pjpVM.dirtyFormControls = [];
                        angular.forEach(pjpVM.dialogForm, function (value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) || (typeof value === 'object' && value.$viewValue == "Invalid Date")) {
                                pjpVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        pjpVM.error_msg = "Required field(s): "
                        for (var i = 0; i < pjpVM.dirtyFormControls.length; i++) {
                            if (i == pjpVM.dirtyFormControls.length - 1) {
                                pjpVM.error_msg += pjpVM.dirtyFormControls[i];
                            }
                            else
                                pjpVM.error_msg += pjpVM.dirtyFormControls[i] + ", ";
                        }
                    }
                }

                $scope.$watch(pjpVM.getFormErrors, pjpVM.errorChanged, true);

                pjpVM.save = function (action, form) {
                    pjpVM.formSubmitted = true;
                    if (form.$invalid) {
                        pjpVM.formInvalid = true;
                        pjpVM.dirtyFormControls = [];
                        angular.forEach(form, function (value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) || (typeof value === 'object' && value.$viewValue == "Invalid Date")) {
                                value.$setTouched();
                                pjpVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        pjpVM.error_msg = "Required field(s): "
                        for (var i = 0; i < pjpVM.dirtyFormControls.length; i++) {
                            if (i == pjpVM.dirtyFormControls.length - 1) {
                                pjpVM.error_msg += pjpVM.dirtyFormControls[i];
                            }
                            else
                                pjpVM.error_msg += pjpVM.dirtyFormControls[i] + ", ";
                        }

                        if (pjpVM.tasksDetails.length == 0) {
                            pjpVM.formInvalid = true;
                            pjpVM.error_msg += " At least one task is needed";

                        }

                    }
                    else if (pjpVM.tasksDetails.length == 0) {
                        pjpVM.formInvalid = true;
                        pjpVM.error_msg = "Required field(s): At least one task is needed"

                    }
                    else {

                        pjpVM.vm.TmxLocation = undefined;
                        pjpVM.vm.LocationName = undefined;
                        var geofenceArray = [];
                        var tasksArray = [];
                        if (pjpVM.multi) {
                            pjpVM.vm.EffectiveStartDate = moment(new Date(pjpVM.startDate)).startOf('day').toISOString();
                            pjpVM.vm.EffectiveEndDate = moment(new Date(pjpVM.endDate)).endOf('day').set('millisecond', 0).toISOString();
                            pjpVM.vm.EffectiveStartDate = new Date(new Date(pjpVM.vm.EffectiveStartDate).setHours(0, 0, 0, 0));
                            pjpVM.vm.EffectiveEndDate = new Date(new Date(pjpVM.vm.EffectiveEndDate).setHours(0, 0, 0, 0));
                        }
                        else {
                            pjpVM.vm.EffectiveStartDate = moment(new Date(pjpVM.date)).endOf('day').set('millisecond', 0).toISOString();
                            pjpVM.vm.EffectiveEndDate = moment(new Date(pjpVM.date)).endOf('day').set('millisecond', 0).toISOString();
                            pjpVM.vm.EffectiveStartDate = new Date(new Date(pjpVM.vm.EffectiveStartDate).setHours(0, 0, 0, 0));
                            pjpVM.vm.EffectiveEndDate = new Date(new Date(pjpVM.vm.EffectiveEndDate).setHours(0, 0, 0, 0));
                        }
                        for (let j = 0; j < pjpVM.tasksDetails.length; j++) {
                            if (pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails[j].Type) == 'Mobilization') {
                                t1 = {
                                    'RouteSequence': pjpVM.tasksDetails[j].TaskSequence,
                                    'PjpTypeLkp': pjpVM.tasksDetails[j].Type,
                                    'EffectiveStartDate': pjpVM.vm.EffectiveStartDate,
                                    'EffectiveEndDate': pjpVM.vm.EffectiveEndDate,
                                    'Description': pjpVM.tasksDetails[j].Description,
                                    'GeofencePJPId': pjpVM.tasksDetails[j].GeofencePJPId,
                                    'TmxGeofence': pjpVM.geofenceFields[pjpVM.tasksDetails[j].Index]
                                };
                                geofenceArray.push(t1);
                            }
                            else if (pjpVM.getVisiblePjpTypeValue(pjpVM.tasksDetails[j].Type) != '') {
                                var t1 = {
                                    'RouteSequence': pjpVM.tasksDetails[j].TaskSequence,
                                    'PjpTypeLkp': pjpVM.tasksDetails[j].Type,
                                    'EffectiveStartDate': pjpVM.vm.EffectiveStartDate,
                                    'EffectiveEndDate': pjpVM.vm.EffectiveEndDate,
                                    'Description': pjpVM.tasksDetails[j].Description,
                                    'LoanApplicationId': pjpVM.tasksDetails[j].GeofenceOrLoanApplication,
                                    'LoanApplicationPjpId': pjpVM.tasksDetails[j].GeofencePJPId
                                };
                                tasksArray.push(t1);

                            }
                        }


                        for (let k = 0; k < pjpVM.removedGeofences.length; k++) {
                            pjpVM.removedGeofences[k].DeleteFlag = true;
                            geofenceArray.push(pjpVM.removedGeofences[k]);
                        }

                        for (let l = 0; i < pjpVM.removedTasks.length; l++) {
                            pjpVM.removedTasks[l].DeleteFlag = true;
                            tasksArray.push(pjpVM.removedTasks[l])
                        }


                        pjpVM.vm.TmxGeofencePjp = geofenceArray;
                        //pjpVM.vm.TmxPjpCluster = clusterArray;
                        pjpVM.vm.TmxLoanApplicationPjp = tasksArray;
                        pjpVM.vm.PJPFrequencyLkpId = pjpVM.repeat;
                        pjpVM.vm.SubFrequency = pjpVM.repeatEvery;


                        // if (getVisibleValueOfRepeat(pjpVM.repeat) == 'DAILY') {
                        //     pjpVM.vm.SubFrequency = 1;
                        //     //pjpVM.vm.WorkingDaysFlag = false;
                        // }
                        // else if (getVisibleValueOfRepeat(pjpVM.repeat) == 'DAILY' && pjpVM.daily == 'Working Days') {
                        //     pjpVM.vm.SubFrequency = 1;
                        //     //pjpVM.vm.WorkingDaysFlag = true;
                        // }
                        if (getVisibleValueOfRepeat(pjpVM.repeat) == 'WEEKLY' || getVisibleValueOfRepeat(pjpVM.repeat) == 'DAILY') {
                            pjpVM.vm.MondayFlag = pjpVM.Weekly[0].Bool;
                            pjpVM.vm.TuesdayFlag = pjpVM.Weekly[1].Bool;
                            pjpVM.vm.WednesdayFlag = pjpVM.Weekly[2].Bool;
                            pjpVM.vm.ThursdayFlag = pjpVM.Weekly[3].Bool;
                            pjpVM.vm.FridayFlag = pjpVM.Weekly[4].Bool;
                            pjpVM.vm.SaturdayFlag = pjpVM.Weekly[5].Bool;
                            pjpVM.vm.SundayFlag = pjpVM.Weekly[6].Bool;

                        }
                        if (pjpVM.multi && (getVisibleValueOfRepeat(pjpVM.repeat) == 'DAILY' || getVisibleValueOfRepeat(pjpVM.repeat) == 'WEEKLY')) {
                            if (!pjpVM.vm.MondayFlag &&
                                !pjpVM.vm.TuesdayFlag &&
                                !pjpVM.vm.WednesdayFlag &&
                                !pjpVM.vm.ThursdayFlag &&
                                !pjpVM.vm.FridayFlag &&
                                !pjpVM.vm.SaturdayFlag &&
                                !pjpVM.vm.SundayFlag) {
                                ToastService.showCustomToast("error", "Please Select Atleast 1 Week Day");
                                return;
                            }
                        }
                        else if (pjpVM.multi && (getVisibleValueOfRepeat(pjpVM.repeat) == 'MONTHLY')) {
                            if (pjpVM.repeatEvery > 31 || pjpVM.repeatEvery <= 0) {
                                ToastService.showCustomToast("error", "For Monthly frequency Days should be in between 1 and 31.");
                                return;
                            }
                        }
                        pjpVM.vm.$saveOrUpdate().then(function (promise) {
                            if (angular.isDefined($state.data.grid.pjpGrid)) $state.data.grid.pjpGrid.dataSource.read();
                            if (angular.isDefined(promise))
                                if (promise.status >= 400) {
                                    pjpVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if (angular.isDefined(promise.data.ModelState)) {
                                        var models = Object.keys(promise.data.ModelState);
                                        models.forEach(function (key) { displayMsg += (promise.data.ModelState[key]) })
                                    }
                                    else {
                                        displayMsg = promise.data.Message;
                                        ToastService.showCustomToast("error", displayMsg);
                                    }
                                }
                                else if (action == "save") {
                                    $state.searchClear = true;
                                    $state.go("^");
                                }
                                else if (action == "saveandnew") {
                                    $state.searchClear = true;
                                    $state.reload($state.current);
                                }
                                else
                                    ToastService.showCustomToast("error", "Some Error Occured");
                        });
                    }
                };

                pjpVM.cancel = function () {
                    $state.searchClear = true;
                    $state.go("^");
                };

                pjpVM.makeClusters = function (TmxPjpCluster) {
                    if (angular.isDefined(TmxPjpCluster) && TmxPjpCluster.length > 0) {
                        pjpVM.tasksFields = [];
                        for (var i = 0; i < TmxPjpCluster.length; i++) {
                            pjpVM.tasksFields.push({
                                UserId: TmxPjpCluster[i].UserId,
                                PjpDate: new Date(TmxPjpCluster[i].PjpDate),
                                EffectiveStartDate: TmxPjpCluster[i].EffectiveStartDate,
                                EffectiveEndDate: TmxPjpCluster[i].EffectiveEndDate,
                                PJPClusterId: TmxPjpCluster[i].PJPClusterId
                            });
                            pjpVM.clusterCount++;
                        }
                    }
                }
                pjpVM.makeTasks = function (TmxPjpTask) {
                    if (angular.isDefined(TmxPjpTask) && TmxPjpTask.length > 0) {
                        pjpVM.tasksFields = [];
                        pjpVM.tasks = [];
                        for (var i = 0; i < TmxPjpTask.length; i++) {
                            pjpVM.tasksFields.push({
                                UserId: TmxPjpTask[i].UserId,
                                PjpDate: new Date(TmxPjpTask[i].PjpDate),
                                EffectiveStartDate: TmxPjpTask[i].EffectiveStartDate,
                                EffectiveEndDate: TmxPjpTask[i].EffectiveEndDate,
                                PJPTaskId: TmxPjpTask[i].PJPTaskId
                            });
                            var t1 = {
                                HiddenValue: pjpVM.tasksCount,
                                VisibleValue: pjpVM.tasksCount.toString()
                            };
                            pjpVM.tasks.push(t1);
                            pjpVM.tasksCount++;
                        }
                    }
                }
                //****************Geofence Control****************
                pjpVM.makeGeofences = function (TmxPjpGeofence) {
                    if (angular.isDefined(TmxPjpGeofence) && TmxPjpGeofence.length > 0) {
                        pjpVM.geofenceFields = [];
                        pjpVM.routes = [];
                        for (var i = 0; i < TmxPjpGeofence.length; i++) {
                            pjpVM.geofenceFields.push({
                                GeofenceId: TmxPjpGeofence[i].GeofenceId,
                                RouteSequence: TmxPjpGeofence[i].RouteSequence,
                                GeofencePoints: TmxPjpGeofence[i].TmxGeofence.GeofencePoints,
                                EffectiveStartDate: TmxPjpGeofence[i].EffectiveStartDate,
                                EffectiveEndDate: TmxPjpGeofence[i].EffectiveEndDate,
                            });

                            var r1 = {
                                HiddenValue: pjpVM.geofenceCount,
                                VisibleValue: pjpVM.geofenceCount.toString()
                            };
                            pjpVM.routes.push(r1);
                            pjpVM.geofenceCount++;
                        }
                    }
                }
                pjpVM.getActionString = function (row) {
                    var TypeVisible = pjpVM.getVisiblePjpTypeValue(row.Type);
                    var userRole = pjpVM.getUserRole(pjpVM.vm.UserId);

                    if (TypeVisible == "Client Verification") {
                        if (userRole == "BDO") {
                            return '/GetListByUserId/' + pjpVM.vm.UserId;
                        }
                        else if (userRole == "BM") {
                            return "/inbox";
                        }
                    }
                    else if (TypeVisible == "Payment Reminder") {
                        return "/GetApprovedList/0";
                    }
                    else if (TypeVisible == "Loan Verification") {
                        if (userRole == "BDO") {
                            return "/GetApprovedList/" + pjpVM.vm.UserId;
                        }
                    }
                    else
                        return undefined;

                }
                pjpVM.showGeofences = function () {

                    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                    var geofenceArray = [];
                    for (var i = 0; i < pjpVM.geofenceCount; i++) {
                        geofenceArray.push(pjpVM.geofenceFields[i].GeofencePoints);
                    }
                    $mdDialog.show({
                        locals: { value: angular.copy(geofenceArray) },
                        controller: ["$scope", "$mdDialog", "NgMap", "value", DialogController],
                        controllerAs: 'dialogCtrl',
                        templateUrl: 'app/private/masterdata/geo-fence/map.html',
                        clickOutsideToClose: true,
                        fullscreen: useFullScreen
                    })
                        .then(function (answer) {
                            $scope.status = 'You said the information was "' + answer + '".';
                        }, function () {
                            $scope.status = 'You cancelled the dialog.';
                        });
                    $scope.$watch(function () {
                        return $mdMedia('xs') || $mdMedia('sm');
                    }, function (wantsFullScreen) {
                        $scope.customFullscreen = (wantsFullScreen === true);
                    });

                }

                pjpVM.showApplications = function (action) {

                    $mdDialog.show({
                        locals: { action: action },
                        controller: 'ApplicationsDialogController',
                        controllerAs: 'applicationsDialogCtrl',
                        templateUrl: 'app/private/masterdata/pjp/applications.html',
                        clickOutsideToClose: true,
                        fullscreen: true
                    })
                        .then(function () {

                        }, function () {

                        });
                    $scope.$watch(function () {
                        return $mdMedia('xs') || $mdMedia('sm');
                    }, function (wantsFullScreen) {
                        $scope.customFullscreen = (wantsFullScreen === true);
                    });


                }                

                pjpVM.getUserRole = function (userId) {
                    for (var i = 0; i < pjpVM.users.length; i++) {
                        if (pjpVM.users[i].HiddenValue == userId) {
                            return pjpVM.users[i].RoleName;
                        }
                    }
                    return undefined;
                }
                pjpVM.CheckMonthlyDays = function (days) {
                    pjpVM.repeatEvery = days;
                };

                pjpVM.CheckWeeklyDateRange = function (repeat) {
                    pjpVM.isInDateRange = true;
                    if (angular.isDefined(repeat) && repeat === lookupService.getLookupIdByHiddenValueAndType("ESTATEMENT_FREQUENCY", '7')) {
                        if (Math.ceil((new Date(pjpVM.endDate) - new Date(pjpVM.startDate)) / (1000 * 3600 * 24)) < 7) {
                            pjpVM.isInDateRange = false;
                            if (pjpVM.dialogForm.Repeat) {
                                pjpVM.dialogForm.Repeat.$setValidity("customError", false);
                            }
                            pjpVM.dateRangeMsg = "Date range must be atleast of 1 week";
                        }
                        else {
                            pjpVM.dialogForm.Repeat.$setValidity("customError", true);
                        }

                    }
                    else if (angular.isDefined(repeat) && repeat === lookupService.getLookupIdByHiddenValueAndType("ESTATEMENT_FREQUENCY", '30')) {
                        if (Math.ceil((new Date(pjpVM.endDate) - new Date(pjpVM.startDate)) / (1000 * 3600 * 24)) < 28) {
                            pjpVM.isInDateRange = false;
                            if (pjpVM.dialogForm.Repeat) {
                                pjpVM.dialogForm.Repeat.$setValidity("customError", false);
                            }
                            pjpVM.dateRangeMsg = "Date range must be atleast of 1 month";
                        }
                        else {
                            pjpVM.dialogForm.Repeat.$setValidity("customError", true);
                        }
                    }
                    else {
                        pjpVM.dialogForm.Repeat.$setValidity("customError", true);
                    }
                };

                //#endregion

                //#region  -------------- Local Functions -------------------------

                function selectDay(index) {
                    pjpVM.Weekly[index].Bool = !pjpVM.Weekly[index].Bool;
                    if (pjpVM.Weekly[index].Bool) {
                        pjpVM.Weekly[index].class = 'selected-day';
                    }
                    else {
                        pjpVM.Weekly[index].class = 'not-selected-day';
                    }
                }

                function getVisibleValueOfRepeat(repeat) {
                    for (var i = 0; i < pjpVM.repeatLookup.length; i++) {
                        if (pjpVM.repeatLookup[i].LookupId == repeat) {
                            return pjpVM.repeatLookup[i].VisibleValue;
                        }
                    }

                    return undefined;
                }

                function EffectiveEndDateChange() {
                    pjpVM.isInDateRange = true;
                    if (new Date(pjpVM.endDate) < new Date(pjpVM.startDate)) {
                        pjpVM.dateGreater = true;
                        pjpVM.dialogForm.EffectiveEndDate.$invalid = true;
                    }
                    else {
                        pjpVM.dateGreater = false;
                        pjpVM.dialogForm.EffectiveEndDate.$invalid = false;


                        if (angular.isDefined(pjpVM.repeat) && getVisibleValueOfRepeat(pjpVM.repeat) == 'WEEKLY') {
                            if (Math.ceil((pjpVM.endDate - pjpVM.startDate) / (1000 * 3600 * 24)) < 7) {
                                pjpVM.isInDateRange = false;
                                pjpVM.dialogForm.Repeat.$setTouched(true);
                                pjpVM.dialogForm.Repeat.$setValidity("customError", false);

                            }
                            else {
                                pjpVM.isInDateRange = true;
                                pjpVM.dialogForm.Repeat.$setTouched(false);
                                pjpVM.dialogForm.Repeat.$setValidity("customError", true);
                            }
                        }
                        else if (angular.isDefined(pjpVM.repeat) && getVisibleValueOfRepeat(pjpVM.repeat) == 'MONTHLY') {
                            if (Math.ceil((pjpVM.endDate - pjpVM.startDate) / (1000 * 3600 * 24)) < 28) {
                                pjpVM.isInDateRange = false;
                                pjpVM.dialogForm.Repeat.$setTouched(true);
                                pjpVM.dialogForm.Repeat.$setValidity("customError", false);

                            }
                            else {
                                pjpVM.isInDateRange = true;
                                pjpVM.dialogForm.Repeat.$setTouched(false);
                                pjpVM.dialogForm.Repeat.$setValidity("customError", true);
                            }
                        }
                    }

                }
                function showFrequencyDropdown() {

                    if (pjpVM.repeat === lookupService.getLookupIdByHiddenValueAndType("ESTATEMENT_FREQUENCY", '7')) {
                        return true;
                    }

                }
                function showFrequencyText() {

                    if (pjpVM.repeat === lookupService.getLookupIdByHiddenValueAndType("ESTATEMENT_FREQUENCY", '30')) {
                        return true;
                    }

                }

                function PopulateLookups() {
                    pjpVM.gridData1 = resolvedData.Geofences;
                    pjpVM.locations = resolvedData.Locations.data;
                    pjpVM.users = resolvedData.Users.data;
                    pjpVM.pjpTypes = lookupService.getLocalLookupsByType("PJP_TYPE");
                    pjpVM.Weekly = [
                        { 'Day': 'M', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'T', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'W', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'T', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'F', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'S', 'Bool': false, 'class': 'not-selected-day' },
                        { 'Day': 'S', 'Bool': false, 'class': 'not-selected-day' },
                    ];
                    pjpVM.repeatLookup = lookupService.getLocalLookupsByType("ESTATEMENT_FREQUENCY");
                    pjpVM.repeatEveryLookup = lookupService.getLocalLookupsByType("PJP_SUB_FREQ");
                }

                function SetFormState() {
                    if (angular.isDefined(resolvedData.Pjp.data)) {

                        if (getVisibleValueOfRepeat(pjpVM.repeat) == 'WEEKLY' || getVisibleValueOfRepeat(pjpVM.repeat) == 'DAILY') {
                            pjpVM.Weekly[0].Bool = resolvedData.Pjp.data.MondayFlag == 1 ? true : false;
                            pjpVM.Weekly[1].Bool = resolvedData.Pjp.data.TuesdayFlag == 1 ? true : false;
                            pjpVM.Weekly[2].Bool = resolvedData.Pjp.data.WednesdayFlag == 1 ? true : false;
                            pjpVM.Weekly[3].Bool = resolvedData.Pjp.data.ThursdayFlag == 1 ? true : false;
                            pjpVM.Weekly[4].Bool = resolvedData.Pjp.data.FridayFlag == 1 ? true : false;
                            pjpVM.Weekly[5].Bool = resolvedData.Pjp.data.SaturdayFlag == 1 ? true : false;
                            pjpVM.Weekly[6].Bool = resolvedData.Pjp.data.SundayFlag == 1 ? true : false;
                            for (var i = 0; i < pjpVM.Weekly.length; i++) {
                                if (pjpVM.Weekly[i].Bool) {
                                    pjpVM.Weekly[i].class = 'selected-day';
                                }


                            }
                        }
                        else if (getVisibleValueOfRepeat(pjpVM.repeat) == 'MONTHLY') {
                            if (resolvedData.Pjp.data.MonthDayFlag) {
                                pjpVM.monthly = 'Day of the Month';
                            }
                            else if (!resolvedData.Pjp.data.MonthDayFlag) {
                                pjpVM.monthly = 'Day of the Week';

                            }
                        }

                        if (resolvedData.Pjp.data.PJPFrequencyLkpId == null) {
                            pjpVM.multi = false;
                            pjpVM.single = true;
                            pjpVM.date = new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z');
                            if (new Date(pjpVM.minDate) > new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z'))
                                pjpVM.minDate = new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z');

                        }

                        else if (resolvedData.Pjp.data.PJPFrequencyLkpId == lookupService.getLookupIdByHiddenValueAndType('ESTATEMENT_FREQUENCY', '1') || resolvedData.Pjp.data.PJPFrequencyLkpId == lookupService.getLookupIdByHiddenValueAndType('ESTATEMENT_FREQUENCY', '7') || resolvedData.Pjp.data.PJPFrequencyLkpId == lookupService.getLookupIdByHiddenValueAndType('ESTATEMENT_FREQUENCY', '30')) {
                            pjpVM.multi = true;
                            pjpVM.single = false;
                            pjpVM.startDate = new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z');
                            pjpVM.startTime = new Date(pjpVM.startDate);
                            pjpVM.date = new Date();
                            pjpVM.repeat = resolvedData.Pjp.data.PJPFrequencyLkpId;
                            pjpVM.repeatEvery = resolvedData.Pjp.data.SubFrequency;
                            pjpVM.endDate = new Date(resolvedData.Pjp.data.EffectiveEndDate + 'Z');
                            pjpVM.endTime = new Date(pjpVM.endDate);
                            if (new Date(pjpVM.minDate) > new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z'))
                                pjpVM.minDate = new Date(resolvedData.Pjp.data.EffectiveStartDate + 'Z');
                        }

                        if (resolvedData.Pjp.data.TmxGeofencePjp && resolvedData.Pjp.data.TmxGeofencePjp.length > 0) {
                            for (var j = 0; j < resolvedData.Pjp.data.TmxGeofencePjp.length; j++) {
                                t1 = {
                                    'Type': resolvedData.Pjp.data.TmxGeofencePjp[j].PJPTypeLkp,
                                    'Description': resolvedData.Pjp.data.TmxGeofencePjp[j].Description,
                                    'TaskSequence': resolvedData.Pjp.data.TmxGeofencePjp[j].RouteSequence,
                                    'GeofenceOrLoanApplication': resolvedData.Pjp.data.TmxGeofencePjp[j].TmxGeofence.GeofenceName,
                                    'EffectiveStartDate': "",
                                    'EffectiveEndDate': "",
                                    'Index': j == 0 ? 0 : j,
                                    'isMobilization': true,
                                    'GeofencePJPId': resolvedData.Pjp.data.TmxGeofencePjp[j].GeofencePjpId
                                };
                                pjpVM.tasksDetails.push(t1);

                                var t2 = {
                                    'GeofenceId': resolvedData.Pjp.data.TmxGeofencePjp[j].TmxGeofence.GeofenceId,
                                    'RouteSequence': resolvedData.Pjp.data.TmxGeofencePjp[j].RouteSequence,
                                    'GeofencePoints': resolvedData.Pjp.data.TmxGeofencePjp[j].TmxGeofence.GeofencePoints,
                                    'EffectiveStartDate': resolvedData.Pjp.data.TmxGeofencePjp[j].TmxGeofence.EffectiveStartDate,
                                    'EffectiveEndDate': resolvedData.Pjp.data.TmxGeofencePjp[j].TmxGeofence.EffectiveEndDate,

                                };
                                var t3 = {
                                    HiddenValue: pjpVM.tasksDetailsCount,
                                    VisibleValue: pjpVM.tasksDetailsCount.toString()
                                };
                                pjpVM.tasks.push(t3);
                                pjpVM.tasksDetailsCount++;
                                pjpVM.geofenceFields.push(t2);


                            }
                        }
                        if (resolvedData.Pjp.data.TmxLoanApplicationPjp && resolvedData.Pjp.data.TmxLoanApplicationPjp.length > 0) {
                            for (let k = 0; k < resolvedData.Pjp.data.TmxLoanApplicationPjp.length; k++) {
                                t1 = {
                                    'Type': resolvedData.Pjp.data.TmxLoanApplicationPjp[k].PjpTypeLkp,
                                    'Description': resolvedData.Pjp.data.TmxLoanApplicationPjp[k].Description,
                                    'TaskSequence': resolvedData.Pjp.data.TmxLoanApplicationPjp[k].RouteSequence,
                                    'GeofenceOrLoanApplication': resolvedData.Pjp.data.TmxLoanApplicationPjp[k].LoanApplicationId,
                                    'EffectiveStartDate': "",
                                    'EffectiveEndDate': "",
                                    'Index': k == 0 ? 0 : k,
                                    'isMobilization': false,
                                    'GeofencePJPId': resolvedData.Pjp.data.TmxLoanApplicationPjp[k].LoanApplicationPjpId
                                };
                                pjpVM.tasksDetails.push(t1);

                                t2 = {
                                    LoanApplicationId: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].LoanApplicationPjpId,
                                    Type: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].PjpTypeLkp,
                                    Description: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].Description,
                                    TaskSequence: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].RouteSequence,
                                    EffectiveStartDate: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].EffectiveStartDate,
                                    EffectiveEndDate: resolvedData.Pjp.data.TmxLoanApplicationPjp[k].EffectiveEndDate,
                                };
                                t3 = {
                                    HiddenValue: pjpVM.tasksDetailsCount,
                                    VisibleValue: pjpVM.tasksDetailsCount.toString()
                                };
                                pjpVM.tasks.push(t3);
                                pjpVM.tasksDetailsCount++;
                                pjpVM.geofenceFields.push(t2);
                            }
                        }
                        pjpVM.geofenceCount = pjpVM.geofenceFields.length;
                        pjpVM.tasksDetailsCount--;
                        pjpVM.tasksCount = pjpVM.tasksFields.length;

                        pjpVM.vm = resolvedData.Pjp.data;
                        pjpVM.isEdit = true;
                        pjpVM.vm.CreatedDate = new Date(resolvedData.Pjp.data.EffectiveStartDate);

                        if ($state.data.info != true) {
                            pjpVM.EndDateReadonly = false;
                        }
                        else {
                            pjpVM.readonly = true;
                            pjpVM.StartDateReadonly = true;
                            pjpVM.EndDateReadonly = true;
                            pjpVM.DescriptionDateReadonly = true;
                        }
                        if (resolvedData.Pjp.data.TmxPjpCluster.length > 0) {
                            pjpVM.vm.UserId = pjpVM.vm.TmxPjpCluster[0].UserId;
                        }

                    }
                    else {
                        pjpVM.tasksDetails.push(
                            {
                                Type: "",
                                Description: "",
                                TaskSequence: "",
                                GeofenceOrLoanApplication: "",
                                EffectiveStartDate: "",
                                EffectiveEndDate: "",
                                Index: -1,
                                isMobilization: false,
                                'GeofencePJPId': '0',
                            }
                        );
                        pjpVM.tasksDetailsCount = 1;
                        var t1 = {
                            HiddenValue: pjpVM.tasksDetailsCount,
                            VisibleValue: pjpVM.tasksDetailsCount.toString()
                        };
                        pjpVM.tasks.push(t1);

                        pjpVM.vm = resolvedData.Pjp;
                        pjpVM.vm.EffectiveStartDate = pjpVM.date;
                    }
                }
                //#endregion

                
                //#region  ----------- Child Controllers -----------------------

                function DialogController(value) {

                    var googleMaps = this;
                    googleMaps.scope = $scope;
                    googleMaps.scope.value = value;

                    $scope.hide = function () {
                        $mdDialog.hide();
                    };
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                    $scope.answer = function (answer) {
                        $mdDialog.hide(answer);
                    };
                }

                //#endregion

                (function InitializePage() {
                    PopulateLookups();
                    SetFormState();
                })();

            }]);
})();

